<div mat-dialog-title class="dialog-title">
  <h1 class="headline">{{'mbus-preview-changes.header' | translate }}</h1>

  <eon-ui-icon fxLayout fxLayoutAlign="end" (click)="closeDialog()" class=closeX name="close"></eon-ui-icon>
</div>


<mat-dialog-content fxFlex class="dialog-content">
  <div>
    <mat-tab-group (selectedTabChange)="selectedTabChange($event)" dynamicHeight mat-stretch-tabs
                   animationDuration="200ms" class="tab-group">
      <mat-tab>
        <ng-template mat-tab-label>
          <span matBadge="{{addedDataPoints.length}}"
                matBadgeOverlap="false">{{ 'mbus-preview-changes.tabs.added-data-points' | translate }}</span>
        </ng-template>
        <eis-gateway-bacnet-preview-undeployed-datapoint-table
          [datapoints]="addedDataPoints"></eis-gateway-bacnet-preview-undeployed-datapoint-table>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span matBadge="{{updatedDataPoints.length}}"
                matBadgeOverlap="false">{{ 'mbus-preview-changes.tabs.updated-data-points' | translate }}</span>
        </ng-template>
        <eis-gateway-bacnet-preview-undeployed-datapoint-table
          [datapoints]="updatedDataPoints"></eis-gateway-bacnet-preview-undeployed-datapoint-table>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span matBadge="{{deletedDataPoints.length}}"
                matBadgeOverlap="false">{{ 'mbus-preview-changes.tabs.removed-data-points' | translate }}</span>
        </ng-template>
        <eis-gateway-bacnet-preview-undeployed-datapoint-table
          [datapoints]="deletedDataPoints"></eis-gateway-bacnet-preview-undeployed-datapoint-table>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <span matBadge="{{deletedDevices.length}}"
                matBadgeOverlap="false">{{ 'mbus-preview-changes.tabs.removed-devices' | translate }}</span>
        </ng-template>
        <eis-gateway-bacnet-preview-undeployed-device-table
          [devices]="deletedDevices"></eis-gateway-bacnet-preview-undeployed-device-table>
      </mat-tab>

    </mat-tab-group>
  </div>
</mat-dialog-content>


<mat-dialog-actions class="display-flex-justify-space-between">
  <eon-ui-button scheme="redInverted"
                 icon="close"
                 text="{{'general.cancel' | translate}}"
                 (click)="closeDialog()"></eon-ui-button>

    <eon-ui-checkbox *ngIf=" deletedDataPoints.length > 0"
                     [(ngModel)]="deleteDataPointsInIoT"
                     label="{{'bacnet-preview-changes.delete-data-points-iot' | translate}}"></eon-ui-checkbox>

  <eon-ui-button [text]="'mbus-preview-changes.button.deploy' | translate"
                 (click)="applyChanges()"></eon-ui-button>
</mat-dialog-actions>

